import React from 'react';
import TaskItem from './TaskItem';

const PropertyEventTask = ({ title, date, description }) => {
  const onSubmit = data => {
    const promise = new Promise(resolve => {
      setTimeout(() => {
        resolve(data);
      }, 2000);
    });

    return promise;
  };

  return (
    <TaskItem
      title={title}
      date={date}
      description={description}
      onSubmit={onSubmit}
      readOnly
      taskItemType="onProperty"
    />
  );
};

export default React.memo(PropertyEventTask);
